import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Utils from '../utils';
import {
  _LOCALE_,
  ENROLLMENT,
  LOGLOCALE_COOKIE,
  requestUrls,
  templateUrls
} from './../../../base/vars.js';
import Form from './../../base/form.js';
import Spinner from './../../components/spinner.js';
import {
  getParameterByName,
  CookieHandler,
  EventHandler
} from './../../../base/utils.js';
import Analytics from '../../../base/wyn-analytics-module.js';
import {
  setPiplConsent,
  getPiplConsent,
  removePiplConsent,
  setLocalStorage,
} from './../../../base/session-handler.js';
import Join from '../../components/join';
import Login from '../../../components/login';
import Logging from '../../base/logging';

export default Backbone.View.extend({
  tagName: 'div',
  className: 'enroll-form',
  preferredDefault: null,

  events: {
    'change #preferred': 'setPreferredCheckbox',
    'change #separateConsentCheckbox': 'setSeparateConsentCookie',
    'focusout input, select': 'handleValidation',
    'input input': 'handleValidation',
    'change select, input[type="checkbox"]': 'handleValidation',
    'change #country0': 'handleCityZip',
    'change #businessEnrollmentCheckbox': 'toggleBussinessEnrollmentDropdown',
    'input #password': 'handlePasswordFields',
    'input #confirmPassword': 'handlePasswordFields',
    'change #acceptTerms': 'acceptTerms',
    'submit': 'onSubmit'
  },

  initialize() {
    $('.app').append(this.el);
    window.App.Collections.Users.reset();
    window.App.Collections.Users.add(this.model);
    this.getTemplate();
    this.applyLocale();
    this.applyPreferredCheckboxDefault();
    this.checkStateBussinessEnrollment();
  },

  getTemplate() {
    $.ajax({
      url: templateUrls.enroll,
      context: {
        onFail: {
          scrollToElement: $('body')
        }
      },
      success: (r) => {
        this.template = Handlebars.compile(r);
        this.render();
        Utils.initLegalDiscalimerForApp(this);
      }
    });
  },

  handlePasswordFields(e) {
    const attr = this.model.attributes;
    const passwordArr = attr.Customer.Passwords[0];
    passwordArr.NewPassword = attr.newPassword;

    const passwordField = $('input#password'),
      firstNameField = $('input#firstName'),
      lastNameField = $('input#lastName'),
      emailField = $('input#emailAddress');

    const excludesFirstName = Boolean(passwordField.val().indexOf(firstNameField.val()) === -1);
    const excludesLastName = Boolean(passwordField.val().indexOf(lastNameField.val()) === -1);
    const excludesEmail = Boolean(passwordField.val().indexOf(emailField.val().split('@')[0]) === -1);

    if (attr.newPassword === attr.confirmPassword && excludesFirstName && excludesLastName && excludesEmail){
      passwordArr.ConfirmPassword = attr.confirmPassword;
    } else {
      passwordArr.ConfirmPassword = '';
    }
    this.handleValidation(e);
  },

  setGdprProp() {
    let pref = this.model.get('Preferences');

    Utils.setGdprAttributes(
      'countryCode',
      $(this.el)
        .find('#country0')
        .val()
    );
    for (let i = 0; i < pref.length; i++) {
      if (pref[i].PrefType === 'EmailOffers') {
        pref[i].PreferLevel === 'Preferred' ? Utils.setGdprAttributes('optInEmailOffers', true) : Utils.setGdprAttributes('optInEmailOffers', false);
      } else if (pref[i].PrefType === 'ThirdPartyEmailOffers') {
        pref[i].PreferLevel === 'Preferred' ? Utils.setGdprAttributes('optInThirdPartyEmailOffers', true) : Utils.setGdprAttributes('optInThirdPartyEmailOffers', false);
      }
    }
  },

  setUrlFromParams(link, hasParams, urlParams) {
    let url = link;
    if (hasParams){
      url += '?' + urlParams;
    }
    return url;
  },

  onSubmit(e) {
    if (!CookieHandler.getCookie(LOGLOCALE_COOKIE)) {
      Logging.setLogCookie();
    }

    let isValid = Utils.isValid(this.model),
      options = {
        context: {
          onFail: {
            scrollToElement: $('body'),
            formElement: this.$('form')
          }
        }
      };

    Spinner.appendTo(this.$('form'));
    Form.disableFormField(this.$('.submit'));

    if (requestUrls && requestUrls['enroll'] && isValid) {
      const $consentCheckbox = $('#separateConsentCheckbox');
      if ($consentCheckbox.length > 0 && $consentCheckbox[0].checked) {
        setPiplConsent($consentCheckbox[0].checked);
        if(window.digitalData['agreement'] == undefined){
          window.digitalData['agreement'] =  { 'personalInformationProtectionLaw' :  'yes' };
        }else{
          window.digitalData['agreement']['personalInformationProtectionLaw'] =  'yes';
        }
      } else {
        removePiplConsent();
        window.digitalData.agreement && window.digitalData.agreement.personalInformationProtectionLaw && delete(window.digitalData.agreement.personalInformationProtectionLaw);
      }

      //Cleanup businessEnrollment before submit to enroll
      Utils.updateBusinessEnrollmentPayload(this.model);
      //Cleanup Pipl before submit to enroll
      Utils.deletePiplPayload(this.model);

      const data = Join.getEnrollmentFormData();
      this.model.enroll(null, options, data)
        .done((response) => {
          window.localStorage.removeItem(ENROLLMENT);
          const urlParams = new URLSearchParams(window.location.search),
            isPhApp = urlParams.has('platform') && urlParams.has('adobeID'),
            platform = (isPhApp && urlParams.get('platform')) || '',
            isStatusMatch = (urlParams.has('destinationLocation') && urlParams.get('destinationLocation').includes('status-match')) || urlParams.has('status-match'),
            statusMatch = 'status-match';
          const enrollmentWithRes = {
            ...JSON.parse(data),
            ...response,
            isPhApp,
            platform
          };
          setLocalStorage(ENROLLMENT, enrollmentWithRes);
          localStorage.setItem('EMAIL_SENT_NOT_VERIFY', true);
          if (response.mfaToken) {
            const localVerifyIdentityPage = this.setUrlFromParams('/' + _LOCALE_ + templateUrls.verifyIdentityPage, isStatusMatch, statusMatch);
            window.location.assign(localVerifyIdentityPage);
          } else if (response.oktaId) {
            let currentURL = window.location.href;
            let preferencePageURL = currentURL.replace(templateUrls.join, templateUrls.profileSetup);
            const localPreferencePage = this.setUrlFromParams('/' + _LOCALE_ + preferencePageURL, isStatusMatch, statusMatch);
            Login.redirectToOktaLogin(localPreferencePage);
          } else if (response.accountNumber) {
            const localFTSIPage = this.setUrlFromParams('/' + _LOCALE_ + templateUrls.firstTimeSignInPage, isStatusMatch, statusMatch);
            window.location.assign(localFTSIPage);
          }
          Form.enableFormField(this.$('.submit'));
          Spinner.remove(this.$('form'));
        })
        .fail((response) => {
          if (response && response.responseJSON && response.responseJSON.ErrorMessage){
            $('#enroll-error-message').html(response.responseJSON.ErrorMessage);
            $('.notification-banner').remove();
          }
          Utils.scrollToTop();
          Form.enableFormField(this.$('.submit'));
          Spinner.remove(this.$('form'));
        });
    } else {
      Utils.scrollToTop();
      Form.enableFormField(this.$('.submit'));
      Spinner.remove(this.$('form'));
    }
  },

  handleValidation(e) {
    if ($(e.currentTarget).data('binding') !== 'Preferences.0.PreferLevel'  &&  $(e.currentTarget).attr('id') !== 'acceptTerms') {
      Utils.setBindingAttribute(this.model, e);
      Utils.validateBindingAttribute(this.model, e);
      Utils.handleSubmitButton(this.model, this.$('.submit'), e);
    }
  },

  handleCityZip(e) {
    let countryCode = $(e.currentTarget).val(),
      address = 'addresses.0';

    this.checkCountry(countryCode);

    if (Utils.countryRequiresZipcode(countryCode)) {
      this.$cityGroup.detach();
      this.$cityZipRow.html(this.$zipGroup);

      this.$cityGroup.find('input').val('');
      this.model.set(address + '.CityName', '');
    } else {
      this.$zipGroup.detach();
      this.$cityZipRow.html(this.$cityGroup);

      this.$zipGroup.find('input').val('');
      this.model.set(address + '.PostalCode', '');
    }


    this.applyPreferredCheckboxDefault();
  },

  checkCountry(countryCode){
    this.$separateConsent = this.$('.separate-consent-wrapper');
    if(countryCode == 'CN'){
      this.showSeparateConsent();
    } else {
      this.$separateConsent.addClass('hide');
      this.model.set('SeparateConsent.SeparateConsentCheckbox',false);
    }
  },

  showSeparateConsent(){ 
    this.$separateConsent = this.$('.separate-consent-wrapper');
    this.model.set('SeparateConsent.SeparateConsentCheckbox',true);
    this.$separateConsent.removeClass('hide');
    if(getPiplConsent()){
      this.$('#separateConsentCheckbox').trigger('click');
      this.$('#personalInformationProtectionLawLabel').trigger('click');
    }
  },

  setSeparateConsentCookie(e){
    let $currentTarget = $(e.currentTarget);
    this.model.set('SeparateConsent.SeparateConsentCheckbox',true);
    if(!$currentTarget[0].checked){
      this.model.unset('SeparateConsent.Pipl');
      window.digitalData.agreement && window.digitalData.agreement.personalInformationProtectionLaw && delete(window.digitalData.agreement.personalInformationProtectionLaw);
      this.$($currentTarget).parents('.separate-consent-wrapper').find('.separateConsentCheckbox-error').addClass('show');
    } else {
      this.model.set('SeparateConsent.Pipl', true);
      if(window.digitalData['agreement'] == undefined){
        window.digitalData['agreement'] =  { 'personalInformationProtectionLaw' :  'yes' };
      }else{
        window.digitalData['agreement']['personalInformationProtectionLaw'] =  'yes';
      }
      this.$($currentTarget).parents('.separate-consent-wrapper').find('.separateConsentCheckbox-error').removeClass('show');
    }

    // Analytics
    if ($currentTarget[0].checked) {
      if (typeof window._satellite !== 'undefined') {
        window._satellite.track('chinaConsent');
      }
    }


    Utils.setBindingAttribute(this.model, e);
    Utils.validateBindingAttribute(this.model, e);
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
  },

  setPreferredCheckbox(e) {

    let $currentTarget = $(e.currentTarget);
    Utils.setPreferredCheckbox(this.model, $currentTarget);
    Utils.setPreferredCheckboxValue(this.model, 'preferredThirdParty', $currentTarget[0].checked);
  },
  acceptTerms(e){
    let $currentTarget = $(e.currentTarget);
    console.log($currentTarget);
    if(!$currentTarget[0].checked){
      this.model.unset('acceptTerms');
      window.digitalData.agreement && window.digitalData.agreement.acceptTermsforWyndhamRewards && delete(window.digitalData.agreement.acceptTermsforWyndhamRewards);
    } else {
      this.model.set('acceptTerms.checked', true);
      if(window.digitalData['agreement'] == undefined){
        window.digitalData['agreement'] =  { 'acceptTermsforWyndhamRewards' :  'yes' };
      }else{
        window.digitalData['agreement']['acceptTermsforWyndhamRewards'] =  'yes';
      }
    }
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
  },
  initPreferredCheckboxDefault($preferred) {

    if (this.preferredDefault === null && $preferred.length > 0) {
      if ($preferred.attr('checked') && $preferred.attr('checked').length > 0) {
        this.preferredDefault = true;
      } else {
        this.preferredDefault = false;
      }
    }
  },

  applyPreferredCheckboxDefault() {
    let $preferred = $(this.el).find('#preferred, #emailLabel');
    this.initPreferredCheckboxDefault($preferred);
    let locale = _LOCALE_,
      countryCode = $(this.el).find('#country0')
        .val(),
      isResidentUS = !countryCode || countryCode === 'US',
      checked = locale === 'en-us' && isResidentUS && this.preferredDefault;
  
    $preferred.attr('checked', checked);
    Utils.setPreferredCheckboxValue(this.model, 'preferred', checked);
    Utils.setPreferredCheckboxValue(this.model, 'preferredThirdParty', checked);
  },

  applyLocale() {
    if (_LOCALE_) {
      this.model.set('Preferences.1.PreferValue', _LOCALE_);
    } else {
      this.model.set('Preferences.1.PreferValue', 'en-us');
    }
  },

  registerPromotion() {
    let code = null;
    if (window.enrollmentInfo.PromoRuleCode || getParameterByName('promoRuleCode')) {
      code = getParameterByName('promoRuleCode') || window.enrollmentInfo.PromoRuleCode;
    }
    EventHandler.triggerEvent('lite_enroll_complete', {
      pageName: 'light-complete',
      subscribeEstatements: Analytics.processSubscribeEStatements(this.model.get('Preferences.0.PreferLevel')),
      wyndhamRewardsOptIn: Analytics.processSubscribeEStatements(this.model.get('Preferences.2.PreferLevel'))
    });
    if (code) {
      let accountNumber = '';
      if(window.User.accountNumber) {
        accountNumber = window.User.accountNumber;
      } else if (window.User && window.User.membershipId) {
        accountNumber = window.User.membershipId;
      } else {
        console.error('AccountNumber not found in user or user sessionInfo while calling registerPromotion api');
      }

      let data = JSON.stringify({
        // DAI-35745 : Tally BWS - Register for Promotion
        promotionCode: code,
        memberIdentifier: accountNumber
      });
  
      $.ajax({
        url: requestUrls['registerPromotion'],
        type: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        data: data,
        context: {
          onFail: {
            ignoreAllCodes: true
          }
        }
      }).always(r => {
        Utils.validPromotion = r.success;
        Backbone.history.loadUrl('username');
      });
    } else {
      Backbone.history.loadUrl('username');
    }
  },

  // Removing and replacing city/zip in a single flex row because
  // there wasn't a good way to hide flex rows without double row
  // borders showing
  initCityZipField() {
    this.$cityGroup = this.$('[name="city0"]').closest('.form-group');
    this.$zipGroup = this.$('[name="zipCode0"]').closest('.form-group');
    this.$cityZipRow = this.$cityGroup.closest('.flex-form-row');

    let $zipRow = this.$zipGroup.closest('.flex-form-row');

    this.$cityGroup.detach();
    this.$zipGroup.detach();
    $zipRow.remove();

    let $showField = Utils.localeRequiresZipcode(_LOCALE_) ? this.$zipGroup : this.$cityGroup;

    this.$cityZipRow.html($showField);
  },

  checkStateBussinessEnrollment() {
    let $btCheckbox = $('#businessEnrollmentCheckbox');
    Utils.toggleBussinessEnrollmentDropdown($btCheckbox);
  },

  toggleBussinessEnrollmentDropdown(e) {
    let $btCheckbox = $(e.currentTarget);
    Utils.toggleBussinessEnrollmentDropdown($btCheckbox);
  },

  render() {
    this.$el.html(this.template(this.model.toJSON()));
    this.checkStateBussinessEnrollment();
    this.initCityZipField();
    $('.submit').attr('disabled', true);
    Utils.bindBackboneValidation(this);
    Utils.triggerFormChecks();
    Utils.bindDefaultValues(this.model, this.$('form'));
  }
});
